import type { CSSProperties } from 'react';
import { Flex, Spin, LoadingOutlined } from '@/uicomponents';
import styles from './screen-loader.module.css';

const STYLES: Record<string, CSSProperties> = {
  spinner: { fontSize: 'var(--dz-font-size-5xl)' },
};

export function ScreenLoader() {
  return (
    <Flex align='center' justify='center' className={styles.overlay}>
      <Spin indicator={<LoadingOutlined style={STYLES.spinner} spin />} />
    </Flex>
  );
}
